import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsToggleSwitch',
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: 'md',
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['update:isActive'],
    components: {
        SdsIcon: __vue_component__,
    },
});

export default script;
